export default "__VITE_ASSET__Bu76PC1S__"